<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";
  import SigmaCurve from "./diagrams/SigmaCurve.svelte";

  const s = $derived(i18n.t.solutions);
</script>

<section class="section section--rule" id="solutions">
  <div class="container">
    <SectionHead label={s.label} title={s.title} lead={s.lead} />

    <div class="diagram card reveal" use:inview>
      <div class="d-figure">
        <SigmaCurve
          conventional={s.diagram.conventional}
          withTane={s.diagram.withTane}
          axis={s.diagram.axis}
        />
      </div>
      <div class="d-text">
        <h3>{s.diagram.title}</h3>
        <p>{s.diagram.caption}</p>
      </div>
    </div>

    <div class="grid">
      {#each s.items as item, i}
        <article class="card item reveal" use:inview={{ delay: (i % 2) * 100 }}>
          <div class="problem">
            <span class="tag tag-p">{s.problemLabel}</span>
            <h3>{item.problem}</h3>
            <p>{item.problemDetail}</p>
            <p class="stat">{item.stat}</p>
          </div>
          <div class="arrow" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22"><path d="M4 12h16M14 6l6 6-6 6" stroke="var(--green)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="solution">
            <span class="tag tag-s">{s.solutionLabel}</span>
            <p>{item.solution}</p>
          </div>
        </article>
      {/each}
    </div>
  </div>
</section>

<style>
  .diagram {
    margin-top: clamp(2.5rem, 1.5rem + 3vw, 4rem);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(1.5rem, 1rem + 2vw, 3rem);
    align-items: center;
    padding: clamp(1.5rem, 1.2rem + 1.5vw, 2.4rem);
    background:
      radial-gradient(120% 80% at 0% 0%, rgba(95, 179, 100, 0.08), transparent 60%),
      var(--paper-card);
  }
  .d-figure {
    padding: 0.5rem;
  }
  .d-text h3 {
    font-size: var(--fs-h3);
  }
  .d-text p {
    margin-top: 0.9rem;
    color: var(--ink-soft);
    font-size: 0.98rem;
    line-height: 1.85;
  }

  .grid {
    margin-top: 1.2rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem;
  }

  @media (max-width: 760px) {
    .diagram {
      grid-template-columns: 1fr;
    }
  }
  .item {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 1rem 1.2rem;
    padding: clamp(1.5rem, 1.2rem + 1vw, 2rem);
    align-items: start;
  }
  .problem {
    grid-column: 1;
  }
  .arrow {
    grid-column: 2;
    grid-row: 1 / span 2;
    align-self: center;
    width: 42px;
    height: 42px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: var(--sprout-soft);
  }
  .solution {
    grid-column: 1;
    padding-top: 1.1rem;
    border-top: 1px dashed var(--line-strong);
  }

  .tag {
    display: inline-block;
    font-family: var(--font-mono);
    font-size: 0.66rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 0.3em 0.7em;
    border-radius: 999px;
    margin-bottom: 0.7rem;
  }
  .tag-p {
    color: var(--terra-deep);
    background: rgba(194, 105, 60, 0.12);
  }
  .tag-s {
    color: var(--green-deep);
    background: var(--sprout-soft);
  }
  h3 {
    font-size: 1.3rem;
  }
  .problem p {
    margin-top: 0.5rem;
    color: var(--ink-soft);
    font-size: 0.96rem;
    line-height: 1.8;
  }
  .stat {
    margin-top: 0.8rem !important;
    font-family: var(--font-mono);
    font-size: 0.8rem !important;
    color: var(--terra-deep) !important;
    line-height: 1.6 !important;
  }
  .solution p {
    color: var(--ink);
    font-size: 1rem;
    line-height: 1.8;
  }

  @media (max-width: 760px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }
</style>
